import LocalizedStrings from "react-localization";
import axiosInstance from "../HelperAxios/axios";

let language = localStorage.getItem("lang");

const strings = new LocalizedStrings({
  EN: require("./en.json"),
  FA: require("./fa.json"),
  TR: require("./tr.json"),
  AR: require("./ar.json"),
  FI: require("./fi.json"),
  FR: require("./fr.json"),
  EL: require("./el.json"),
  ZH: require("./zh.json"),
});
if (language) {
  strings.setLanguage(language);
}

export default strings;
